import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import T from 'i18n-react';
import JOB_TYPES from '../../enums/JobType';
import LOCATION from '../../enums/Location';
import FontIcon from 'material-ui/FontIcon';

export default class MenuOperationNotLinked extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    handleClick = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        return (
            <div>
                <RaisedButton
                    secondary
                    onClick={this.handleClick}
                    label={T.translate('jobHistory.exportNotLinkButton')}
                    icon={<FontIcon className="material-icons" color={'white'}>cloud_download</FontIcon>}
                />
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                    onRequestClose={this.handleRequestClose}
                >
                    <Menu>
                        <MenuItem onClick={() => this.props.handleClick(JOB_TYPES.CODA, LOCATION.BE)} primaryText={T.translate('jobHistory.exportCodaButton')} />
                        <MenuItem onClick={() => this.props.handleClick(JOB_TYPES.N43, LOCATION.ES)} primaryText={T.translate('jobHistory.exportN43Button')} />
                        <MenuItem onClick={() => this.props.handleClick(JOB_TYPES.FRA, LOCATION.FR)} primaryText={T.translate('jobHistory.exportFrButton')} />
                    </Menu>
                </Popover>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/jobHistory/MenuOperationNotLinked.js